import React, { useEffect, useContext } from "react";
import { UserContext } from "./auth/userContext";
import Routers from "./routes";
import LoadingFrame from "./generalComponents/loadingFrame";

import GuestLayout from "./pages/endOfSummer/layout/nav";
export default function ContentLayout(appProps) {
  const userContext = useContext(UserContext);
  const { pageId, addPageId } = userContext;

  useEffect(() => {
    addPageId();
  }, [addPageId]);
  const contentLayout = (key) => {
    var address = window.location.pathname;
    if (appProps.isLoading) {
      return <LoadingFrame loading={true}></LoadingFrame>;
    }

    if (address == "/login" || address == "/register") {
      return (
        <GuestLayout>
          <Routers {...appProps} />
        </GuestLayout>
      );
    }

    if (address == "/") {
      return (
        <GuestLayout {...appProps}>
          <Routers {...appProps} />
        </GuestLayout>
      );
    }

    // if (address.includes("judge")) {
    //   return (
    //     <JudgeLayout {...appProps}>
    //       <Routers {...appProps} />
    //     </JudgeLayout>
    //   );
    // }

    if (address.includes("end-of-summer")) {
      return (
        <GuestLayout {...appProps}>
          <Routers {...appProps} />
        </GuestLayout>
      );
    }

    if (address === "/events" || address.startsWith("/event/")) {
      return (
        <GuestLayout {...appProps}>
          <Routers {...appProps} />
        </GuestLayout>
      );
    }
    // if (appProps.isAuthenticated && address == "/404") {
    //   return (
    //     <MemberLayout {...appProps}>
    //       <Routers {...appProps} />
    //     </MemberLayout>
    //   );
    // }

    return <Routers {...appProps} />;
  };
  return <div>{contentLayout(pageId)}</div>;
}
